import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "./cn.js";

/** Padded white surface used for grouped content. See design.md §4. */
export function Card({ className, children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...rest}
      className={cn(
        "rounded-2xl border border-slate-200 bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]",
        className,
      )}
    >
      {children}
    </div>
  );
}

/**
 * Uppercase, tracked label used to head a section inside a detail view
 * ("PROPERTY", "DESCRIPTION", "STATUS"). See design.md §4 / §11.
 */
export function SectionLabel({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <h2
      className={cn("text-xs font-semibold uppercase tracking-[0.08em] text-slate-500", className)}
    >
      {children}
    </h2>
  );
}

/** Hairline divider for separating sections inside a card or detail page. */
export function Divider({ className }: { className?: string }) {
  return <hr className={cn("border-t border-slate-200", className)} />;
}
